export { default as Tooltip } from './Tooltip';
export type { Props as TooltipProps } from './Tooltip';
